var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dropdown, FormStatusMessage, MenuItem, FormController, FormLabel, } from '@one-thd/sui-atomic-components';
export var BusinessTypeSelect = function (_a) {
    var tradeTypes = _a.tradeTypes, errorHelperText = _a.errorHelperText, selectProps = __rest(_a, ["tradeTypes", "errorHelperText"]);
    var defaultValue = selectProps.defaultValue || '';
    return (React.createElement("div", { className: "sui-relative sui-z-10" },
        React.createElement(FormController, { required: true, fullWidth: true },
            React.createElement(FormLabel, null, "Business Type"),
            React.createElement(Dropdown, __assign({}, selectProps), (tradeTypes === null || tradeTypes === void 0 ? void 0 : tradeTypes.length) ? (tradeTypes.map(function (tradeType) { return (React.createElement(MenuItem, { key: tradeType === null || tradeType === void 0 ? void 0 : tradeType.type, value: tradeType === null || tradeType === void 0 ? void 0 : tradeType.type }, tradeType === null || tradeType === void 0 ? void 0 : tradeType.description)); })) : (React.createElement(MenuItem, { value: defaultValue }, defaultValue))),
            errorHelperText && (React.createElement(FormStatusMessage, { status: "error" }, errorHelperText)))));
};
